import { createStore } from 'vuex'

/**
 * 全局 Vuex 根 store
 * 后续可将相册「创建/编辑」等多步页面集拆分为独立 namespaced modules 并在此注册
 */
export default createStore({
  // 开发态开启严格模式，禁止在 mutation 外直接改 state
  strict: process.env.NODE_ENV !== 'production',
  state: () => ({}),
  getters: {},
  mutations: {},
  actions: {},
  modules: {}
})
